import { createStore } from 'satcheljs';
var defaultStore = {
    findText: '',
};
export default createStore('findFavorites', defaultStore)();
//# sourceMappingURL=store.js.map